import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    audiciones: [],
  },

  getters: {
    getAudiciones: (state) => state.audiciones,
  },

  mutations: {
    SET_AUDICIONES(state, audiciones) {
      state.audiciones = audiciones;
    },
  },

  actions: {
    async fetchAudiciones({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiasclinicas/${idHistoriaClinica}/audiciones`)
        .then((response) => {
          commit('SET_AUDICIONES', response.data.data);
        });
    },

    async saveAudiciones(context, audiciones) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiasclinicas/${idHistoriaClinica}/audiciones`, audiciones);
    },

    async updateAudiciones(_, audiciones) {
      await axios
        .put(`PoliciaCuadrantes/C3/historiaclinica/${audiciones.fk_idHistoriaClinica}/audiciones/${audiciones.fk_idAudiciones}`, audiciones);
    },
  },
};
